import { Component, OnInit } from '@angular/core';
import { StrucnoUsavrsavanje } from './strucno-usavrsavanje';
import { BaseModalUpdateComponent, ModalContainerService, ModalService } from 'yt-ng-framework';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'yt-strucno-usavrsavanje-modal-update',
  templateUrl: './strucno-usavrsavanje-modal-update.component.html'
})
export class StrucnoUsavrsavanjeModalUpdateComponent extends BaseModalUpdateComponent<StrucnoUsavrsavanje> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<StrucnoUsavrsavanje>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService
  ) {
    super(modalContainerService, activeModal,modalService);
  }


  ngOnInit() {
  }

}
